// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCookie_container__3G6S8","text":"CustomCookie_text__3vrgO","offsetText":"CustomCookie_offsetText__1KNhO"};